import {
  type OrderDetailedItemVatExplanation,
  VatExemptionReason,
} from "mws-ts-v2-sdk";

type Costs = {
  itemVatExplanation?: OrderDetailedItemVatExplanation;
  handlingVatExplanation?: OrderDetailedItemVatExplanation;
};

const useIsSalesTax = (costsParam: MaybeRefOrGetter<Costs | undefined>) => {
  return computed(() => {
    const costs = toValue(costsParam);

    return (
      costs?.itemVatExplanation?.reason ===
        VatExemptionReason.UsSalesTaxApplies ||
      costs?.handlingVatExplanation?.reason ===
        VatExemptionReason.UsSalesTaxApplies
    );
  });
};

export default useIsSalesTax;
